var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m121.693 36.469a1.749 1.749 0 0 0 1.75-1.75v-8.319a1.75 1.75 0 0 0 -1.75-1.75h-106.893a1.75 1.75 0 0 0 -1.75 1.75v8.316a1.749 1.749 0 0 0 1.75 1.75h1.82v9h-2.532v-3.46a1.75 1.75 0 0 0 -3.5 0v3.46h-4.281a1.749 1.749 0 0 0 -1.75 1.75v6.168a1.749 1.749 0 0 0 1.75 1.75h4.281v17.73h-4.281a1.749 1.749 0 0 0 -1.75 1.75v6.168a1.749 1.749 0 0 0 1.75 1.75h4.281v3.46a1.75 1.75 0 0 0 3.5 0v-3.46h2.531v9h-1.819a1.749 1.749 0 0 0 -1.75 1.75v8.318a1.75 1.75 0 0 0 1.75 1.75h106.893a1.75 1.75 0 0 0 1.75-1.75v-8.319a1.749 1.749 0 0 0 -1.75-1.75h-1.82v-55.062zm-105.144-8.316h103.394v4.816h-103.394zm-8.492 20.814h8.562v2.668h-8.562zm6.031 6.168h2.531v17.73h-2.531zm-6.031 23.9v-2.67h8.562v2.668zm111.886 20.812h-103.394v-4.816h103.394zm-3.57-8.316h-96.254v-55.062h96.254z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.246 87.743a1.749 1.749 0 0 0 1.754-1.75v-43.986a1.75 1.75 0 1 0 -3.5 0v43.986a1.749 1.749 0 0 0 1.746 1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.494 87.743a1.749 1.749 0 0 0 1.75-1.75v-43.986a1.75 1.75 0 0 0 -3.5 0v43.986a1.749 1.749 0 0 0 1.75 1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.742 87.743a1.749 1.749 0 0 0 1.75-1.75v-43.986a1.75 1.75 0 1 0 -3.5 0v43.986a1.749 1.749 0 0 0 1.75 1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.99 87.743a1.749 1.749 0 0 0 1.75-1.75v-43.986a1.75 1.75 0 1 0 -3.5 0v43.986a1.749 1.749 0 0 0 1.75 1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.5 87.743a1.749 1.749 0 0 0 1.75-1.75v-43.986a1.75 1.75 0 0 0 -3.5 0v43.986a1.749 1.749 0 0 0 1.75 1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.75 87.743a1.749 1.749 0 0 0 1.75-1.75v-43.986a1.75 1.75 0 0 0 -3.5 0v43.986a1.749 1.749 0 0 0 1.75 1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 87.743a1.749 1.749 0 0 0 1.75-1.75v-43.986a1.75 1.75 0 0 0 -3.5 0v43.986a1.749 1.749 0 0 0 1.75 1.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/container.de717884139e67d7b00165fe00023b1c.svg";
export { ForwardRef as ReactComponent };